module.exports = __webpack_public_path__ + "static/media/slider-l2.8cb27b6e.webp";